export default function Footer() {
  return (
    <footer className="bg-white dark:bg-[#070D1B] border-t border-[#E5E7EB] dark:border-white/10">
      <div className="max-w-7xl mx-auto px-8 lg:px-16 py-14">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <div className="flex items-center justify-center" style={{ width: 150, height: 150, marginBottom: '0.5rem' }}>
              <img
                src="https://public.readdy.ai/ai/img_res/bf69462a-f180-485e-aa00-1081295b3e42.png"
                alt="Henexa AI"
                style={{ width: 150, height: 150, objectFit: 'contain' }}
              />
            </div>
            <p className="text-sm text-[#0B2A4A]/50 dark:text-white/40 tracking-wide">Clarity in Motion.</p>
          </div>

          <nav className="flex flex-wrap items-center gap-9">
            {[
              { label: 'Services', href: '#system-overview' },
              { label: 'Industries', href: '#industries' },
              { label: 'How It Works', href: '#how-it-works' },
              { label: 'Contact', href: '#contact' },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-[#0B2A4A]/55 hover:text-[#0B2A4A] dark:text-white/50 dark:hover:text-white tracking-wide transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-6 border-t border-[#E5E7EB] dark:border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#0B2A4A]/40 dark:text-white/35 tracking-wide">
            &copy; {new Date().getFullYear()} Henexa AI. All rights reserved.
          </p>
          <p className="text-xs text-[#0B2A4A]/40 dark:text-white/35 tracking-wide">
            Structured systems. Measurable results.
          </p>
        </div>
      </div>
    </footer>
  );
}
